import GoogleMaps from './GoogleMaps';

export { GoogleMaps };
